import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component,  OnDestroy,  OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DFAdmin, DFCountryVariableCharges } from 'app/df-management/shared/df-management-admin-data.modal';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import { LoaderService } from 'app/shared/services/loader.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CalendarService } from '../calendar.service';
@Component({
  selector: 'app-df-country',
  templateUrl: './df-country.component.html',
  styleUrls: ['./df-country.component.scss']
})
export class DfCountryComponent implements OnInit, OnDestroy  {
  parentFlag = false;
  isEditVisible = false;
  countryList: DFAdmin[];
  pageCountry: DFAdmin[] = [];
  searchText: string;
  editCountryData: DFAdmin;
  constructor(private fb: FormBuilder,
    private dfManagementService: DfManagementService,
    private toastr: ToastrService,
    private loader: LoaderService,
    private translate: TranslateService,
    public navigationService: NavigationService,
    private calendarService: CalendarService) {
  }

  ngOnDestroy() {
    this.parentFlag = false;
  }

  ngOnInit(): void {
    this.calendarService.calendarVal$.subscribe((calValue: boolean) => {
      this.parentFlag = calValue;
    })
    this.getAllCountries();
  }

  getCalendarFlag() {

  }

  getCountryData() {
    this.ngOnInit();
  }

  clickCountryData() {
    this.parentFlag = false;
  }

  getAllCountries() {
    this.loader.startLoad();
    this.dfManagementService.getAllCountry()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((country: DFAdmin[]) => {
        this.countryList = country['data']
      }, (error: HttpErrorResponse) => {
        this.toastr.error(error['error_message'] || this.translate.instant('df-management.table.error-fetching-country')
        );
      });
  }

  goBackAdmin() {
    this.navigationService.dfAdminManagemnt().list().go();
  }

  onCloseEditClick() {
    this.isEditVisible = false;
  }

  createNewCountry() {
    this.parentFlag = !this.parentFlag;
  }

  editCountry(item: DFAdmin) {
    this.isEditVisible = !this.isEditVisible;
    this.editCountryData = item;
  }
}
